<template>
    <Question :question="question">
        <div class="form-group">
            <div class="input-group">
                <select class="form-control" v-model="sex" required>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                </select>
            </div>
        </div>
    </Question>
</template>

<script>
import Question from '../Question.vue'


export default {
  name: 'Sex',
  props: {
      question: String
  },
  components: {
      Question
  },
  data: function() {
      return {"sex": "Male"};
  }
}
</script>